import { createSlice } from "@reduxjs/toolkit";
import { createConnectionRequest, getVitrineAssesses } from "./Thunk";

export const landingPage = createSlice({
  name: "landingPage",

  initialState: {
    modalIsShown: false,
    isLoading: false,
    vitrineAssessments: [],
    vitrineInventories: [],
    vitrineTests: [],
  },
  reducers: {
    ChangeModalIsShown(state, action) {
      state.modalIsShown = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createConnectionRequest.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createConnectionRequest.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getVitrineAssesses.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getVitrineAssesses.fulfilled, (state, action) => {
      state.vitrineAssessments = action.payload?.assessments || [];
      state.vitrineInventories = action.payload?.inventories || [];
      state.vitrineTests = action.payload?.tests || [];
      state.isLoading = false;
    });
  },


});

export const { ChangeModalIsShown } = landingPage.actions;

export default landingPage.reducer;
